export default __webpack_public_path__ + "static/media/ads-T20_2.5702c14f.jpg";